// Site Copy overrides: staff-edited text/images keyed by page path + original content, applied at DOM level.
import { API } from "./api";

let cache = null;
let loading = null;
const listeners = new Set();

const normPath = (p) => (p || "/").split("?")[0].split("#")[0].replace(/\/+$/, "") || "/";
const normText = (s) => (s || "").replace(/\s+/g, " ").trim();

export const loadOverrides = (force = false) => {
  if (cache && !force) return Promise.resolve(cache);
  if (loading && !force) return loading;
  loading = fetch(`${API}/site-copy`).then((r) => r.json()).then((d) => {
    cache = { text: {}, image: {} };
    for (const it of d.items || []) {
      const bucket = cache[it.kind] || (cache[it.kind] = {});
      (bucket[it.path] ||= {})[it.kind === "text" ? normText(it.original) : it.original] = it.value;
    }
    listeners.forEach((fn) => fn(cache));
    return cache;
  }).catch(() => (cache = cache || { text: {}, image: {} }));
  return loading;
};
export const onOverrides = (fn) => { listeners.add(fn); return () => listeners.delete(fn); };
export const currentOverrides = () => cache;

const lookup = (kind, path, key) => {
  if (!cache) return undefined;
  const b = cache[kind] || {};
  return b[path]?.[key] ?? b["*"]?.[key];
};

const SKIP = new Set(["SCRIPT", "STYLE", "TEXTAREA", "INPUT", "SELECT", "NOSCRIPT"]);
const inEditor = (n) => !!(n.parentElement && n.parentElement.closest("[data-copy-editor]"));

export const applyOverrides = (root = document.body, path = window.location.pathname) => {
  if (!cache || !root) return;
  const p = normPath(path);
  const walker = document.createTreeWalker(root, NodeFilter.SHOW_TEXT, { acceptNode: (n) => (n.parentElement && !SKIP.has(n.parentElement.tagName) && !inEditor(n) && normText(n.nodeValue) ? NodeFilter.FILTER_ACCEPT : NodeFilter.FILTER_REJECT) });
  let n;
  while ((n = walker.nextNode())) {
    const original = n.__dkOriginal ?? normText(n.nodeValue);
    const v = lookup("text", p, original);
    if (v !== undefined) {
      if (normText(n.nodeValue) !== normText(v)) { n.__dkOriginal = original; const lead = n.nodeValue.match(/^\s*/)[0]; const trail = n.nodeValue.match(/\s*$/)[0]; n.nodeValue = `${lead}${v}${trail}`; }
    } else if (n.__dkOriginal !== undefined && normText(n.nodeValue) !== n.__dkOriginal) {
      n.nodeValue = n.__dkOriginal; delete n.__dkOriginal; // override removed → restore
    }
  }
  root.querySelectorAll("img").forEach((img) => {
    if (img.closest("[data-copy-editor]")) return;
    const original = img.dataset.dkOriginalSrc || img.getAttribute("src") || "";
    const key = original.startsWith("http") ? original : original;
    const v = lookup("image", p, key) ?? lookup("image", p, new URL(original, window.location.origin).pathname);
    if (v && img.getAttribute("src") !== v) { img.dataset.dkOriginalSrc = original; img.src = v; }
    else if (!v && img.dataset.dkOriginalSrc && img.getAttribute("src") !== img.dataset.dkOriginalSrc) { img.src = img.dataset.dkOriginalSrc; delete img.dataset.dkOriginalSrc; }
  });
};

// Original content of a text node / image for the editor.
export const originalOf = (node) => (node.nodeType === 3 ? node.__dkOriginal ?? normText(node.nodeValue) : node.dataset.dkOriginalSrc || node.getAttribute("src") || "");
export { normPath, normText };
